var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('objects.attachmentRequest.title'),
      "isDialogActive": _vm.isDialogActive,
      "leftText": _vm.$t('create'),
      "rightText": _vm.$t('createAndSend'),
      "loading": _vm.isRequestImageLoading,
      "rightDisabled": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.requestImages
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "required": "",
      "rules": _vm.requiredRule,
      "label": _vm.$t('common.nouns.title')
    },
    model: {
      value: _vm.sharedName,
      callback: function callback($$v) {
        _vm.sharedName = $$v;
      },
      expression: "sharedName"
    }
  }), _c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.isExpiringLink ? _vm.$t('timeLine.ReportActivityBoxShareComponent.expiringLink') : _vm.$t('timeLine.ReportActivityBoxShareComponent.nonExpiringLink')
      }
    },
    model: {
      value: _vm.isExpiringLink,
      callback: function callback($$v) {
        _vm.isExpiringLink = $$v;
      },
      expression: "isExpiringLink"
    }
  }), _vm.isExpiringLink ? _c('v-text-field', {
    attrs: {
      "type": "date",
      "outlined": "",
      "required": "",
      "rules": _vm.requiredRule,
      "label": _vm.$t('timeLine.ReportActivityBoxShareComponent.question')
    },
    model: {
      value: _vm.validBy,
      callback: function callback($$v) {
        _vm.validBy = $$v;
      },
      expression: "validBy"
    }
  }) : _vm._e(), _c('report-activity-box-share-component-screen-order', {
    attrs: {
      "screenSelection": _vm.screenSelection
    }
  }), _c('v-divider', {
    staticClass: "pb-2"
  }), _vm.unselectedSelectableScreens.length ? _c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "items": _vm.unselectedSelectableScreens,
      "disabled": !_vm.unselectedSelectableScreens.length && !_vm.newScreen,
      "append-outer-icon": "mdi-plus"
    },
    on: {
      "click:append-outer": _vm.addNewScreen
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "textContent": _vm._s(_vm.$t("screenEnum.".concat(item, ".title")))
          }
        }), _c('v-list-item-subtitle', {
          domProps: {
            "textContent": _vm._s(_vm.$t("screenEnum.".concat(item, ".description")))
          }
        })], 1)];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(_vm.$t("screenEnum.".concat(item, ".title"))))])];
      }
    }], null, false, 2745439418),
    model: {
      value: _vm.newScreen,
      callback: function callback($$v) {
        _vm.newScreen = $$v;
      },
      expression: "newScreen"
    }
  }) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }